import script from "./CoachCreateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoachCreateView.vue?vue&type=script&setup=true&lang=ts"

import "./CoachCreateView.vue?vue&type=style&index=0&id=1934bec3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1934bec3"]])

export default __exports__